const useGetSetting = <T>(entity?: {
    settings?: { key: string; value?: T }[]
}) => {
    const getSetting = (key: string, defaultValue?: T): T | undefined => {
        const setting = entity?.settings?.find((setting) => setting.key === key)
        return setting ? setting.value : defaultValue
    }

    return getSetting
}

export default useGetSetting
